<template>
  <div class="page">
    <el-card>
      <el-form class="checkedCodeContainer" label-width="10em">
        <div class="header">
          <span class="title">已核销文件列表</span>
          <div class="uploader">
            <input
              type="file"
              ref="checkedCodeUploader"
              :accept="$store.getters['upload/fileAccept'].excel"
              @input="onCheckedFileChange"
            />
            <el-button type="success" size="mini">上传新文件</el-button>
          </div>
        </div>
        <el-table :data="checkedCodeData.fileList" fit center>
          <el-table-column type="expand">
            <template slot-scope="scope">
              <div class="errorMessage" v-for="(i, n) in scope.row.remarkList" :key="n">
                <div class="row">行：{{ i.row }}</div>
                <div class="msg">{{ i.msg }}</div>
                <div v-if="i.code" class="code">错误码：{{ i.code }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="fileName" label="名称" align="center"> </el-table-column>
          <el-table-column label="上传时间" align="center">
            <template slot-scope="scope">
              {{ scope.row.createTime | formatTime }}
            </template>
          </el-table-column>
          <el-table-column prop="totalCount" label="核销码数量" align="center"> </el-table-column>
          <el-table-column prop="successCount" label="核销成功数量" align="center"> </el-table-column>
          <el-table-column prop="tenantId" label="状态" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status === 0" type="info">审核中</el-tag>
              <el-tag v-if="scope.row.status === 1" type="danger">失败</el-tag>
              <el-tag v-if="scope.row.status === 2" type="success">成功</el-tag>
              <el-tag v-if="scope.row.status === 3">已绑定</el-tag>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data: () => ({
    foo: 'bar',
    checkedCodeData: {
      id: '',
      file: null,
      fileName: '',
      fileList: []
    }
  }),
  computed: {
    ...mapGetters({})
  },
  watch: {},
  methods: {
    ...mapActions({}),
    formatRemarkList(val) {
      if (!val) {
        return []
      }
      try {
        let list = JSON.parse(val)
        return list.map(j => ({
          code: j.checkCode,
          row: j.rowNum,
          msg: j.errorMessage
        }))
      } catch (e) {
        return []
      }
    },
    getDetail() {
      this.$http
        .get('/boom-center-product-service/sysAdmin/checkCodePool/checkCodeFileList', {
          params: {
            type: 2,
            size: 100,
            id: this.$route.query.id
          }
        })
        .then(res => {
          this.checkedCodeData.fileList = res.list.map(i => {
            i.remarkList = this.formatRemarkList(i.remark)
            return i
          })
        })
        .catch(err => {
          this.$message.error('请求失败')
        })
    },
    onCheckedFileChange(e) {
      if (e.target.files.length) {
        const file = e.target.files[0]

        if (file.size > 10240000) {
          this.$message.error('文件过大，大于10M，请分开上传')
          return
        }
        this.checkedCodeData.file = file
        this.checkedCodeData.fileName = file.name
        const loading = this.$loading()
        let formData = new FormData()
        formData.append('file', this.checkedCodeData.file)
        this.$http
          .post(`/boom-mix-biz-service/sysAdmin/checkCodePool/writeOff/${this.$route.query.id}`, formData)
          .then(res => {
            this.$message.success('添加已核销文件成功！')
          })
          .catch(err => {
            this.$message.error(err.msg)
          })
          .finally(() => {
            this.$refs.checkedCodeUploader.value = null
            loading.close()
            this.getDetail()
          })
      }
    }
  },
  created() {},
  mounted() {
    this.getDetail()
  }
}
</script>

<style lang="less" scoped>
.page {
  width: 100%;
}
.fileList {
  text-align: center;
  .fileItem {
    width: 100%;
    display: flex;
    .column {
      flex-basis: 25%;
      flex-shrink: 0;
      flex-grow: 0;
      padding: 5px;
      border-left: 1px solid var(--border);
      border-top: 1px solid var(--border);
      &:last-child {
        border-right: 1px solid var(--border);
      }
    }
    &:last-child {
      border-bottom: 1px solid var(--border);
    }
    &.header {
      background: var(--background);
      line-height: 30px;

      .column {
        padding: 0;
      }
    }
  }
  .tips {
    border: 1px solid var(--border);
  }
}
.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  .uploader {
    position: relative;
    right: 0;
    input {
      .wrap;
      width: 100%;
      opacity: 0;
      position: absolute;
    }
  }
}
.checkedCodeContainer {
  .fileInfo {
    display: flex;
    align-items: center;
    .name {
      margin-right: 20px;
      color: var(--primary);
    }
  }
}
.uploader {
  position: relative;
  right: 0;
  input {
    .wrap;
    width: 100%;
    opacity: 0;
    position: absolute;
  }
}
</style>
